<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<div class="toolbar">
    <vaadin-upload target="./media-upload" #upload></vaadin-upload>
    <paper-button (click)="onDeleteClick()"><iron-icon icon="delete"></iron-icon>remove selected files</paper-button>
</div>
<file-list-http #list></file-list-http>
